import { useCallback, useSyncExternalStore } from 'react';

import { isPhiBlurSourceActive, PhiBlurSource, subscribePhiBlur } from '@/utils/phiBlur';

/** Whether PHI is currently blurred because of `source`, re-rendering as that changes. */
export default function usePhiBlurSource(source: PhiBlurSource) {
  const getSnapshot = useCallback(() => isPhiBlurSourceActive(source), [source]);

  return useSyncExternalStore(subscribePhiBlur, getSnapshot, getSnapshot);
}
